const config = {
    baseUrl: process.env.REACT_APP_API,
    exportPPTXBaseUrl: process.env.REACT_APP_AWS_PPTX_LAMBDA,
    CLOUDINARY_UPLOAD_PRESET: 'sblopwiq',
    CLOUDINARY_BASE_URL: 'https://api.cloudinary.com/v1_1/dvystkvxw',
    CLOUDINARY_DOWNLOAD_URL: 'https://res.cloudinary.com/dvystkvxw/image/upload',
};

export default config;
